import { TableSchema } from '../metadata-schema';
import { Niveau } from '../enums/Niveau';

export const dim_ll_leerling: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_ll_leerling",
	"description": "Definitie voor dimension tabel dim_ll_leerling uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Leerlingspecifiek"
	],
	"properties": {
		"ll_co_basisschooladvies": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ll_co_niveau_lj3": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ll_d_geboortedatum": {
			"type": "string",
			"format": "date",
			"label": "Geboortedatum",
			"category": "Leerling",
			"datePicker": false,
			"example": "18-04-2011",
			"description": "De geboortedatum van deze leerling.",
			"blocklist": {
				"bestuur": true
			}
		},
		"ll_d_eerste_inschrijving": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ll_d_diploma": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description-somtoday": "De datum van de examenstatus waarmee de leerling geslaagd is.",
			"description-magister": "De datum waarop de leerling na het slagen uitgeschreven wordt."
		},
		"ll_d_in_nederland": {
			"type": "string",
			"format": "date",
			"label": "Datum in Nederland",
			"category": "Leerling",
			"example": "16-05-2023",
			"description": "De datum sinds wanneer de leerling in Nederland verblijft.\nDeze datum wordt gebruikt om te bepalen of een niet-Nederlandse leerling op 1 oktober van een schooljaar korter dan 2 jaar\nin Nederland verblijft en daarom als nieuwkomer wordt aangemerkt.\nNieuwkomers tellen binnen de onderwijsresultaten niet mee voor de indicatoren Bovenbouwsucces en Onderbouwsnelheid.",
			"blocklist": {
				"bestuur": true
			}
		},
		"ll_d_inschrijving": {
			"type": "string",
			"format": "date",
			"label": "Inschrijvingsdatum",
			"category": "Instroom - Uitstroom",
			"example": "01-08-2022",
			"description-somtoday": "De datum waarop deze leerling is ingeschreven op deze instelling. Dit is de begindatum van de registratie in Somtoday.\nBij leerlingen met meerdere registraties is dit de begindatum van de actuele registratie.",
			"description-magister": "De datum waarop deze leerling is ingeschreven op deze instelling.\nBij leerlingen die zijn uitgeschreven en later zijn teruggekomen, is dit de laatste inschrijvingsdatum."
		},
		"ll_d_ned_onderwijs_sinds": {
			"type": "string",
			"format": "date",
			"label": "Nederlands onderwijs sinds",
			"category": "Leerling",
			"example": "16-05-2023",
			"description": "De datum sinds wanneer de leerling in Nederland onderwijs volgt. De bekostiging van nieuwkomers wordt berekend vanaf de dag van eerste inschrijving op een school.",
			"blocklist": {
				"bestuur": true
			}
		},
		"ll_d_laatste_opp": {
			"type": "string",
			"format": "date",
			"label": "Datum laatste OPP",
			"category": "Prestatieanalyse",
			"example": "01-08-2022",
			"description": "Begindatum van het meest recente ontwikkelingsperspectief (OPP) van deze leerling.",
			"blocklist": {
				"geenVSO": true
			}
		},
		"ll_d_uitschrijving": {
			"type": "string",
			"format": "date",
			"label": "Uitschrijvingsdatum",
			"category": "Instroom - Uitstroom",
			"example": "13-06-2023",
			"description-somtoday": "De datum waarop deze leerling is uitgeschreven op deze instelling. Dit is de einddatum van de registratie.\nBij geslaagde leerlingen is dit meestal gelijk aan de diplomadatum.",
			"description-magister": "De vertrekdatum van deze leerling. Bij geslaagde leerlingen is dit meestal de diplomadatum."
		},
		"ll_des_onderwijssoort_svb": {
			"type": "string",
			"label": "Onderwijssoort SvB",
			"category": "Vervolgopleiding",
			"searchKeys": [
				"school van bestemming"
			],
			"example": "Voortgezet speciaal onderwijs, HBO opleiding, ...",
			"description-somtoday": "De Onderwijssoort Vervolgonderwijs zoals vastgelegd bij de beëindiging van de registratie. Bij een tussentijdse\nuitschrijving (einddatum niet 31-07) is dit de onderwijssoort per eerstvolgende 1 oktober, als die samen met het leerjaar\nis ingevuld; anders de onderwijssoort bij instroom.\nAan de hand van deze onderwijssoort en het Leerjaar Vervolgonderwijs kan bij leerlingen die naar een andere VO-school\nuitstromen worden bepaald of zij doorstromen, doubleren, en op- of afstromen. Dat gebeurt voor leerlingen die zijn\nuitgeschreven tussen 31-07 en 30-09, of waarvan de onderwijssoort en het leerjaar per eerstvolgende 1 oktober zijn ingevuld.",
			"description-magister": "De vervolgopleiding per eerstvolgende 1 oktober, zoals vastgelegd in Magister.\nAls de leerling dit jaar uitstroomt naar een andere VO-instelling, wordt dit veld gebruikt om het niveau en leerjaar van\nvolgend schooljaar te herkennen voor het bepalen van de doorstroom."
		},
		"ll_des_uitschrijving": {
			"type": "string",
			"label": "Uitschrijvingsreden",
			"category": "Instroom - Uitstroom",
			"example": "Geslaagd, Andere school, ...",
			"description": "De vertrek- of uitschrijvingsreden die is vastgelegd bij de uitschrijving van de leerling.\nLeerlingen die worden uitgeschreven met reden \"Geslaagd\" worden (ook zonder bevorderingsresultaat of examendeelname) aangemerkt als Geslaagd."
		},
		"ll_des_vertrekstatus": {
			"type": "string",
			"label": "Vertrekstatus",
			"category": "Instroom - Uitstroom",
			"example": "Geslaagd, Niet bevorderd, ...",
			"description-somtoday": "De inhoud van het veld \"Vertrekstatus\" bij de beëindiging van de registratie van de leerling.\nWanneer hier Geslaagd, Afgewezen of (Niet) Bevorderd is gekozen, wordt deze waarde gebruikt bij de bepaling van de Doorstroom\nvan deze uitgeschreven leerling en wordt deze leerling als zodanig meegeteld bij de verschillende indicatoren van de Onderwijsresultaten.",
			"description-magister": "Het laatste bevorderingsresultaat van deze leerling."
		},
		"ll_fun_volledige_naam": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Roepnaam, eventueel voorvoegsel en achternaam van de leerling."
		},
		"ll_is_actueel": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ll_is_apcg": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "APCG",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ll_is_cohortstatus_tot_volledig": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Cohortstatus tot volledig",
			"category": "Doorstroom",
			"example": "Ja, Nee",
			"description": "Ja als deze leerling in leerjaar 1 bij deze instelling is ingestroomd en daarom tot en met het gekozen \nschooljaar een volledige schoolloopbaan heeft gevolgd."
		},
		"ll_is_svb_per_1okt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ll_nm_achternaam": {
			"type": "string",
			"label": "Achternaam",
			"category": "Leerling",
			"example": "Vries, Jong, ...",
			"description": "Achternaam van de leerling zonder voorvoegsel.",
			"blocklist": {
				"bestuur": true
			}
		},
		"ll_nm_basisschooladvies": {
			"label": "Basisschooladvies",
			"category": "Vooropleiding",
			"example": "PrO, VMBO b, VMBO k, VMBO (g)t, HAVO, VWO, ...",
			"description": "Het geldende schooladvies van de basisschool, omgezet naar een niveau zoals CumLaude kent.\nWordt gevuld op de volgorde van basisschooladvies (DUO), basisschooladvies (definitief), basisschooladvies (voorlopig), basisschooladvies (oud) en basisschooladvies (herzien).\nNiet gevuld voor adviezen die niet herkend konden worden.\nCombinatie-adviezen van 3 niveaus (bijv. VMBO b t/m VMBO (g)t) zijn omgezet naar het middelste niveau.\nCombinatie-adviezen van meer dan 3 niveaus zijn \"Te breed\".",
			"type": "string",
			"schema": Niveau
		},
		"ll_nm_basisschooladvies_definitief": {
			"label": "Basisschooladvies (definitief)",
			"category": "Vooropleiding",
			"example": "PrO, VMBO b, VMBO k, VMBO (g)t, HAVO, VWO, ...",
			"description": "Het definitieve schooladvies van de basisschool, omgezet naar een niveau zoals CumLaude kent.\nNiet gevuld voor adviezen die niet herkend konden worden.\nCombinatie-adviezen van 3 niveaus (bijv. VMBO b t/m VMBO (g)t) zijn omgezet naar het middelste niveau.\nCombinatie-adviezen van meer dan 3 niveaus zijn \"Te breed\".",
			"type": "string",
			"schema": Niveau
		},
		"ll_nm_basisschooladvies_duo": {
			"label": "Basisschooladvies (DUO)",
			"category": "Vooropleiding",
			"example": "PrO, VMBO b, VMBO k, VMBO (g)t, HAVO, VWO, ...",
			"description": "Het schooladvies van de basisschool volgens DUO, omgezet naar een niveau zoals CumLaude kent.\nNiet gevuld voor adviezen die niet herkend konden worden.\nCombinatie-adviezen van 3 niveaus (bijv. VMBO b t/m VMBO (g)t) zijn omgezet naar het middelste niveau.\nCombinatie-adviezen van meer dan 3 niveaus zijn \"Te breed\".",
			"type": "string",
			"schema": Niveau
		},
		"ll_nm_basisschooladvies_herzien": {
			"label": "Basisschooladvies (herzien)",
			"category": "Vooropleiding",
			"example": "PrO, VMBO b, VMBO k, VMBO (g)t, HAVO, VWO, ...",
			"description": "Het herziene schooladvies van de basisschool, omgezet naar een niveau zoals CumLaude kent.\nNiet gevuld voor adviezen die niet herkend konden worden.\nCombinatie-adviezen van 3 niveaus (bijv. VMBO b t/m VMBO (g)t) zijn omgezet naar het middelste niveau.\nCombinatie-adviezen van meer dan 3 niveaus zijn \"Te breed\".",
			"type": "string",
			"schema": Niveau
		},
		"ll_nm_basisschooladvies_oud": {
			"label": "Basisschooladvies (oud)",
			"category": "Vooropleiding",
			"example": "PrO, VMBO b, VMBO k, VMBO (g)t, HAVO, VWO, ...",
			"blocklist": {
				"somtoday": true
			},
			"description": "Het schooladvies van de basisschool, omgezet naar een niveau zoals CumLaude kent.\nNiet gevuld voor adviezen die niet herkend konden worden.\nCombinatie-adviezen van 3 niveaus (bijv. VMBO b t/m VMBO (g)t) zijn omgezet naar het middelste niveau.\nCombinatie-adviezen van meer dan 3 niveaus zijn \"Te breed\".",
			"type": "string",
			"schema": Niveau
		},
		"ll_nm_basisschooladvies_voorlopig": {
			"label": "Basisschooladvies (voorlopig)",
			"category": "Vooropleiding",
			"example": "PrO, VMBO b, VMBO k, VMBO (g)t, HAVO, VWO, ...",
			"description": "Het voorlopige schooladvies van de basisschool, omgezet naar een niveau zoals CumLaude kent.\nNiet gevuld voor adviezen die niet herkend konden worden.\nCombinatie-adviezen van 3 niveaus (bijv. VMBO b t/m VMBO (g)t) zijn omgezet naar het middelste niveau.\nCombinatie-adviezen van meer dan 3 niveaus zijn \"Te breed\".",
			"type": "string",
			"schema": Niveau
		},
		"ll_nm_geslacht": {
			"type": "string",
			"label": "Geslacht",
			"category": "Leerling",
			"example": "Man, Vrouw",
			"description": "Het geslacht van de leerling: Man, Vrouw of Onbekend."
		},
		"ll_nm_leerling": {
			"type": "string",
			"label": "Leerling",
			"category": "Leerling",
			"example": "Vries, Lucas de (123456); Jong, Julia de (23456); ...",
			"description": "De achternaam, roepnaam, eventueel voorvoegsel en het leerlingnummer tussen haakjes.",
			"blocklist": {
				"bestuur": true
			}
		},
		"ll_nm_nationaliteit1": {
			"type": "string",
			"label": "1ste Nationaliteit",
			"category": "Leerling",
			"filter": false,
			"example": "Nederlandse, Turkse, ...",
			"description": "De eerste nationaliteit van de leerling, zoals vastgelegd in het bronsysteem.\nBij leerlingen met een dubbele nationaliteit is niet gedefinieerd welk van beide nationaliteiten als eerste telt."
		},
		"ll_nm_nationaliteit2": {
			"type": "string",
			"label": "2de Nationaliteit",
			"category": "Leerling",
			"filter": false,
			"example": "Nederlandse, Turkse, ...",
			"description": "De tweede nationaliteit van de leerling, zoals vastgelegd in het bronsysteem.\nBij leerlingen met een dubbele nationaliteit is niet gedefinieerd welk van beide nationaliteiten als tweede telt."
		},
		"ll_nm_niveau_lj3": {
			"label": "Niveau leerjaar 3",
			"category": "Plaatsing",
			"example": "VMBO b, PrO, HAVO / VWO, ...",
			"description": "Het niveau van deze leerling toen hij/zij voor het eerst in leerjaar 3 zat, mits deze leerling bij deze instelling\nin leerjaar 3 heeft gezeten.",
			"type": "string",
			"schema": Niveau
		},
		"ll_nm_niveau_svb": {
			"label": "Niveau SvB",
			"category": "Vervolgopleiding",
			"searchKeys": [
				"school van bestemming"
			],
			"example": "VMBO b, PrO, HAVO / VWO, ...",
			"description-somtoday": "Het niveau van de vervolgopleiding, als de leerling uitstroomt naar een andere VO-instelling.\nDit wordt bepaald uit de onderwijssoort vervolgonderwijs zoals vastgelegd bij de beëindiging van de registratie. Bij een\ntussentijdse uitschrijving (einddatum niet 31-07) is dat de onderwijssoort per eerstvolgende 1 oktober, als die samen met\nhet leerjaar is ingevuld; anders de onderwijssoort bij instroom.\nAls de leerling is uitgeschreven tussen 31-07 en 30-09, of als de onderwijssoort en het leerjaar per eerstvolgende 1 oktober\nzijn ingevuld, wordt aangenomen dat dit het niveau van de leerling is per eerstvolgende 1 oktober, en wordt dit veld\ngebruikt voor de bepaling van de doorstroom.",
			"description-magister": "Het niveau van de vervolgopleiding, als de leerling uitstroomt naar een andere VO-instelling.\nDit wordt bepaald uit de omschrijving van de vervolgopleiding per eerstvolgende 1 oktober, zoals vastgelegd in Magister.\nDit wordt gebruikt voor de bepaling van de doorstroom.",
			"type": "string",
			"schema": Niveau
		},
		"ll_nm_roepnaam": {
			"type": "string",
			"label": "Roepnaam",
			"category": "Leerling",
			"example": "Lucas, Julia, ...",
			"description": "De roepnaam van de leerling.",
			"blocklist": {
				"bestuur": true
			}
		},
		"ll_nm_schoolsoort_svb": {
			"type": "string",
			"label": "Schoolsoort SvB",
			"category": "Vervolgopleiding",
			"searchKeys": [
				"school van bestemming"
			],
			"example": "HO, ROC, ...",
			"description-somtoday": "De schoolsoort van de gekozen vervolgschool van deze leerling.",
			"description-magister": "Het type vervolgschool van deze leerling."
		},
		"ll_nm_schoolsoort_svh": {
			"type": "string",
			"label": "Schoolsoort SvH",
			"category": "Vooropleiding",
			"searchKeys": [
				"school van herkomst"
			],
			"example": "BAO - Basisonderwijs, VO - Voorgezet onderwijs, Speciaal onderwijs, ...",
			"description-somtoday": "De schoolsoort van de school van herkomst van deze leerling, zoals vastgelegd in de (actuele) registratie.",
			"description-magister": "Het schooltype van de (laatste) school van herkomst van deze leerling. Indien gevuld is dit de vorige school, of anders de basisschool."
		},
		"ll_nm_svb": {
			"type": "string",
			"label": "School van bestemming",
			"category": "Vervolgopleiding",
			"searchKeys": [
				"school van bestemming"
			],
			"example": "Hogeschool CumLaude",
			"description": "De naam van de gekozen vervolgschool van deze leerling."
		},
		"ll_nm_svh": {
			"type": "string",
			"label": "School van herkomst",
			"category": "Vooropleiding",
			"searchKeys": [
				"Basisschool",
				"school van herkomst"
			],
			"example": "Basisschool De Regenboog",
			"description-somtoday": "De naam van de school van herkomst van deze leerling, zoals vastgelegd in de (actuele) registratie.",
			"description-magister": "De naam van de (laatste) school van herkomst van deze leerling. Indien gevuld is dit de vorige school, of anders de basisschool."
		},
		"ll_nm_voorvoegsel": {
			"type": "string",
			"label": "Voorvoegsel",
			"category": "Leerling",
			"example": "de, van, ...",
			"description": "Voorvoegsel behorende bij de achternaam van deze leerling.",
			"blocklist": {
				"bestuur": true
			}
		},
		"ll_nm_woonplaats": {
			"type": "string",
			"label": "Woonplaats",
			"category": "Leerling",
			"example": "Utrecht, Groningen, Maastricht, ...",
			"description": "De woonplaats van de leerling. Deze woonplaats is opgezocht via de 4 cijfers van de postcode."
		},
		"ll_nr_citototaalscore": {
			"type": "integer",
			"label": "CITO totaalscore",
			"category": "Vooropleiding",
			"example": "501 - 550",
			"description": "De totaalscore van de doorstroomtoets van de basisschool."
		},
		"ll_nr_examenopstroom_diploma": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Het aantal keren dat de leerling is opgestroomd bij het behalen van het diploma."
		},
		"ll_nr_examenopstroom_instroom": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "1 als de leerling in bezit is van een diploma op een bepaald niveau en instroomt op een hoger niveau."
		},
		"ll_nr_leerling": {
			"type": "integer",
			"label": "Leerlingnummer",
			"category": "Leerling",
			"example": "123456, 23456, ...",
			"description": "Het unieke leerlingnummer van de leerling.",
			"blocklist": {
				"bestuur": true
			}
		},
		"ll_nr_leerjaar_diploma": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Het leerjaar van de leerling ten tijde van het (laatste) diploma."
		},
		"ll_nr_leerjaar_instroom": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Het leerjaar op het moment dat de leerling instroomde.\nDit is relevant voor de bepaling van eventuele doublures bij Cohortrendement tot;\nals de leerling sinds de instroom minder leerjaren omhoog is gegaan dan het aantal verstreken schooljaren,\nis er sprake van één of meer doublures."
		},
		"ll_nr_leerjaar_svb": {
			"type": "integer",
			"label": "Leerjaar SvB",
			"category": "Vervolgopleiding",
			"searchKeys": [
				"school van bestemming"
			],
			"example": "1-6",
			"description-somtoday": "Het leerjaar van de vervolgopleiding, als de leerling uitstroomt naar een andere VO-instelling.\nDit is het leerjaar vervolgonderwijs zoals vastgelegd bij de beëindiging van de registratie. Bij een tussentijdse\nuitschrijving (einddatum niet 31-07) is dat het leerjaar per eerstvolgende 1 oktober, als dat samen met de onderwijssoort\nis ingevuld; anders het leerjaar bij instroom.\nAls de leerling is uitgeschreven tussen 31-07 en 30-09, of als de onderwijssoort en het leerjaar per eerstvolgende 1 oktober\nzijn ingevuld, wordt aangenomen dat dit het leerjaar van de leerling is per eerstvolgende 1 oktober, en wordt dit veld\ngebruikt voor de bepaling van de doorstroom.",
			"description-magister": "Het leerjaar van de vervolgopleiding, als de leerling uitstroomt naar een andere VO-instelling.\nDit wordt bepaald uit de omschrijving van de vervolgopleiding per eerstvolgende 1 oktober, zoals vastgelegd in Magister.\nDit wordt gebruikt voor de bepaling van de doorstroom."
		},
		"ll_nr_pc4": {
			"type": "integer",
			"label": "Postcode",
			"category": "Leerling",
			"example": "1000 - 9950",
			"description": "De 4 cijfers van de actuele postcode van de leerling. Aan de hand hiervan wordt de woonplaats bepaald.\nHet percentage leerlingen woonachtig in een postcode die is aangemerkt als armoedeprobleemcumulatiegebied (APCG)\nis van invloed op de correctiefactoren die de inspectie toepast op de norm van de\nindicatoren Onderbouwsnelheid, Bovenbouwsucces en Examencijfers."
		},
		"ll_pic_pasfoto": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"bestuur": true
			}
		},
		"ll_pk_key": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"bestuur": true
			}
		}
	}
};
